<template>
  <div class="market">
    <div class="market__innerwrap">
      <h1 class="market__title" v-html="page.title"></h1>
      <div class="market__buttons">
        <a
          v-for="(market, key) in markets"
          :key="key"
          class="market__button"
          href="#"
          v-on:click.prevent="marketClick(key)"
        >{{market.title}}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'Market',
  computed: {
    ...mapState(['markets', 'pages']),
    page() {
      return this.pages.market;
    },
  },
  methods: {
    ...mapActions(['setMarket']),
    marketClick(market) {
      this.setMarket(market);
      this.$router.push({ name: 'Cover' });
    },
  },
};
</script>

<style lang="scss">
@import '../styles/helpers';

.market {
  @include section;
  // display: flex;
  height: 100vh;
  // flex-direction: column;
  box-sizing: border-box;
  // padding: 200px 0 10px;
  // justify-content: center;
  position: relative;
  z-index: 1;

  @include section-bg-dot;

  &__innerwrap {
    // width: 100%;
    // display: block;
    // box-sizing: border-box;
    margin-top: 112px;
    padding-top: 49px;
    padding-bottom: 49px;
    background: $c_grey--light;
  }

  &__title {
    @include font-heading;
  }

  &__buttons {
    display: flex;
    flex-wrap: wrap;
    max-width: 800px;
    margin: 43px 0 -20px;
  }

  &__button {
    @include button;
    display: block;
    min-width: 235px;
    margin: 0 20px 20px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Market.vue